import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Typography, Card } from 'antd';
import { LockOutlined, CloudUploadOutlined, SafetyOutlined } from '@ant-design/icons';
import { useAuth } from '../contexts/AuthContext';
import { isLocalAuthEnabled } from '../utils/localAuth';
import './Home.css';

const { Title, Paragraph } = Typography;

const Home = () => {
  const navigate = useNavigate();
  const { isAuthenticated } = useAuth();
  const localAuthEnabled = isLocalAuthEnabled();

  return (
    <div className="home-page">
      <section className="hero">
        <div className="hero-content">
          <img src="/logo.svg" alt="Mediatropy" className="hero-logo" />
          <Title level={1} className="hero-title">
            Secure File Transfer
          </Title>
          <Paragraph className="hero-description">
            Share large files with password protection or a private passwordless link.
            Designed exclusively for Mediatropy team members.
          </Paragraph>
          <div className="hero-actions">
            {isAuthenticated ? (
              <Button 
                type="primary" 
                size="large"
                onClick={() => navigate('/dashboard')}
              >
                Go to Dashboard
              </Button>
            ) : (
              <Button 
                type="primary" 
                size="large"
                onClick={() => navigate('/login')}
              >
                {localAuthEnabled ? 'Continue as Ari Joki' : 'Login with Google'}
              </Button>
            )}
          </div>
        </div>
      </section>

      <section className="features">
        <div className="container">
          <div className="features-grid">
            <Card className="feature-card">
              <CloudUploadOutlined className="feature-icon" />
              <Title level={4}>Large File Support</Title>
              <Paragraph>
                Upload large files with ease. Our system handles files of any size efficiently.
              </Paragraph>
            </Card>

            <Card className="feature-card">
              <LockOutlined className="feature-icon" />
              <Title level={4}>Password Protected</Title>
              <Paragraph>
                Password protection is the default, with long passwordless links available when needed.
              </Paragraph>
            </Card>

            <Card className="feature-card">
              <SafetyOutlined className="feature-icon" />
              <Title level={4}>Secure Storage</Title>
              <Paragraph>
                Files are securely stored on AWS S3 with server-side encryption.
              </Paragraph>
            </Card>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Home;
